import { KeyboardEvent, MouseEvent, useCallback, useRef, useState } from "react"
import Actionbar from "src/components/common/actionbar/Authactionbar"
import { Message } from "src/components/common/form/Message"
import useUiuxStore from "src/store/useUiuxStore"
import { InsertRowHandler } from "src/utils/grid/GridHandlerContent"


import { AgGridReact } from "ag-grid-react"
import { Content_KSK2120_R01 } from "./Content_KSK2120_R01"
import { defaultKSK2120_R01Dto, KSK2120_R01Dto } from "./Dto_KSK2120_R01"
import { SearchSection_KSK2120_R01 } from "./SearchSection_KSK2120_R01"
import { useKSK2120_R01Store } from "./Store_KSK2120_R01"
import { Table_KSK2120_R01 } from "./Table_KSK2120_R01"

/**
 * 사용자 관리 컨테이너 컴포넌트
 * 사용자 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_KSK2120_R01 = () => {
	const { 
		KSK2120_R01List,
		insertKSK2120_R01List,
		initData,
	} = useKSK2120_R01Store();
	const { setMessage } = useUiuxStore();
	
	const gridRef = useRef<AgGridReact<KSK2120_R01Dto> | null>(null);

	

	const {
		nowWorkNoHandleFoucsId,
		getProductMaterialFieldHandlers,
		fetchData,
		defaultKSK2120_R01Row,
		initContainerData,
		handleInsertClick,
		handleDeleteClick,
		handleSaveClick,
		buttonDisabled,
	} = Content_KSK2120_R01({
		gridRef,
		setMessage,
		
	});

    const [clickable, setClickable] = useState(true);

	return <div className="content-container">
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={() => {}}
			onInitClick={initData}
		/>
		
		<SearchSection_KSK2120_R01
			onEnterKeyDown={() => { fetchData() }} 
			nowWorkNoHandleFoucsId={nowWorkNoHandleFoucsId}
			getFieldHandlers={getProductMaterialFieldHandlers}
		/>
		<div className="flex-1 flex">
			<div className="w-full h-full flex flex-col  p-[12px] gap-[12px]">
				
				<Table_KSK2120_R01
					clickable={clickable}				setClickable={setClickable}
					gridRef={gridRef}
					defaultKSK2120_R01Row={defaultKSK2120_R01Row}
				/>
			</div>
		</div>
	</div>
}
